<template>
  <div class="resource-container">
    <div class="resource-card">
      <div class="card-content">
        <div class="tags-section">
          <span v-if="resource.ai_assisted" class="tag-item">Ai Assisted</span>
          <span v-if="resource.grade" class="tag-item">{{
            resource.grade
          }}</span>
          <span v-if="resource.subject" class="tag-item">{{
            resource.subject
          }}</span>
        </div>
        <h2 class="resource-title">{{ resource.title }}</h2>
        <p class="resource-description">{{ resource.short_description }}</p>
        <div
          v-if="resource.tags && resource.tags.length > 0"
          class="resource-standards"
        >
          <span
            v-for="(tag, index) in resource.tags"
            :key="
              Array.isArray(tag)
                ? tag.join(',')
                : typeof tag === 'object'
                  ? Object.keys(tag).join(',')
                  : tag
            "
            class="standard-item"
          >
            <span>{{
              Array.isArray(tag)
                ? tag.join(", ")
                : typeof tag === "object"
                  ? Object.keys(tag).join(", ")
                  : tag
            }}</span>
            <span v-if="index < resource.tags.length - 1" class="separator">
              |
            </span>
          </span>
        </div>
      </div>
    </div>
    <ActionButton class="view-button" @click="hopToLessonPackage(resource.id)">
      View More
    </ActionButton>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { useRouter } from "vue-router";
import ActionButton from "../common/ActionButton.vue";

defineProps({
  resource: Object,
});

const router = useRouter();

const hopToLessonPackage = (id) => {
  router.push({
    name: "MyLessonPackagePage",
    params: {
      id: id,
    },
  });
};
</script>

<style scoped>
.resource-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
}

.resource-card {
  border: 1px solid #d8dae5;
  border-radius: 16px;
  padding: 16px;
  width: 100%;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.tags-section {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
}

.tag-item {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.014px;
  color: #e00069;
  white-space: nowrap;
}

.resource-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xxl);
  line-height: 36px;
  color: var(--primary-blue);
  margin: 0;
  width: 100%;
}

.resource-description {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #3b4648;
  margin: 0;
  width: 100%;
}

.resource-standards {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.014px;
  color: #0478ce;
  width: 100%;
}

.standard-item {
  display: inline;
}

.separator {
  margin: 0 4px;
}

.view-button {
  width: 150px;
  height: 56px;
  padding: 10px 16px;
  border-radius: 12px;
}

.view-button :deep(.action-button) {
  width: 150px;
  height: 56px;
  padding: 10px 16px;
  border-radius: 12px;
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.024px;
}

.view-button:hover {
  background-color: #005bb5;
}

.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px dashed #d8dae6;
}

@media (max-width: 768px) {
  .view-button {
    width: 100%;
  }

  .resource-title {
    font-size: var(--fs-large);
  }

  .resource-description {
    font-size: var(--fs-small);
  }
}
</style>
